/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';
const authSettings = require('../authSettings.json');
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || authSettings.clientId || '',
    authority: process.env.REACT_APP_AUTHORITY || authSettings.authority || '',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || authSettings.redirectUri || '',
  },
  cache: {
    cacheLocation: process.env.REACT_APP_CACHE_LOCATION || authSettings.cacheLocation || '', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

const login_scopes = JSON.parse(process.env.REACT_APP_LOGIN_SCOPES ?? null) || authSettings.loginRequest.scopes;
export const loginRequest = {
  scopes: [...login_scopes],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: process.env.REACT_APP_GRAPH_ME || authSettings.graphConfig.graphMeEndpoint || '',
};

const token_scopes = JSON.parse(process.env.REACT_APP_TOKEN_SCOPES ?? null) || authSettings.tokenRequest.scopes;
export const tokenRequest = {
  scopes: [...token_scopes],
};
